export type SpacingKey =
  | "x4"
  | "x8"
  | "x12"
  | "x16"
  | "x20"
  | "x24"
  | "x28"
  | "x32"
  | "x36"
  | "x40"
  | "x44"
  | "x48"
  | "x52"
  | "x56"
  | "x60"
  | "x64"
  | "x68"
  | "x72"
  | "x76"
  | "x80"
  | "x84"
  | "x88"
  | "x92"
  | "x96"
  | "x100"
  | "x104";

export type SpacingProps = {
  gap?: SpacingKey;
  m?: SpacingKey; // margin
  mx?: SpacingKey; // margin x
  my?: SpacingKey; // margin y
  mt?: SpacingKey; // margin top
  mr?: SpacingKey; // margin bottom
  mb?: SpacingKey; // margin right
  ml?: SpacingKey; // margin left
  p?: SpacingKey; // padding
  px?: SpacingKey; // padding x
  py?: SpacingKey; // padding y
  pt?: SpacingKey; // padding top
  pr?: SpacingKey; // padding bottom
  pb?: SpacingKey; // padding right
  pl?: SpacingKey; // padding left
  br?: SpacingKey; // border-radius
  "br-t"?: SpacingKey; // border-radius top
  "br-r"?: SpacingKey; // border-radius right
  "br-b"?: SpacingKey; // border-radius bottom
  "br-l"?: SpacingKey; // border-radius left
  "min-h"?: SpacingKey; // min-height
  "min-w"?: SpacingKey; // min-width
  "max-h"?: SpacingKey; // max-height
  "max-w"?: SpacingKey; // max-width
};

export type SpacingPropsKeys = keyof SpacingProps;
const spacingPropsKeys: SpacingPropsKeys[] = [
  "gap",
  "m",
  "mx",
  "my",
  "mt",
  "mr",
  "mb",
  "ml",
  "p",
  "px",
  "py",
  "pt",
  "pr",
  "pb",
  "pl",
  "br",
  "br-t",
  "br-r",
  "br-b",
  "br-l",
  "min-h",
  "min-w",
  "max-h",
  "max-w",
];

export const createSpacingClasses = <TProps extends SpacingProps>(
  props: TProps,
) => {
  return spacingPropsKeys
    .map((key) => (props[key] ? `${key}-${props[key]}` : ""))
    .filter(Boolean);
};
